import { IProjectLearner } from 'app/models/responses/IProjectLearner';
import React, { useEffect, useMemo, useState } from 'react';
import buildQuery, { Expand, Select } from 'odata-query';
import axios from 'utils/axios';
import { IFileItem } from 'app/models/responses/IFileItem';
import { ExceptionHandler } from 'components';
import { rootConfig } from 'config';
import { id } from 'date-fns/locale';
import { useSnackbar } from 'notistack';
import { Box, Button, TableCell, TableRow, makeStyles } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import getFileUrl from 'utils/getFileUrl';

interface IProps {
  course: IProjectLearner;
}

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const RowItem = ({ course }: IProps) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleFileDownload = async (file: IFileItem | null) => {
    if (!file) return;

    try {
      saveAs(getFileUrl(file), file.displayName! + file.extension!);
    } catch (error) {
      enqueueSnackbar(<ExceptionHandler exception={error} />, { variant: 'error' });
    }
  };

  return (
    <TableRow>
      <TableCell>{course.project?.courseRevision?.course?.name}</TableCell>
      <TableCell>
        {course.certificate ? (
          <Button
            size='small'
            startIcon={<GetAppIcon />}
            color='secondary'
            variant='contained'
            onClick={() => handleFileDownload(course.certificate!)}
          >
            Download
          </Button>
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell>
        {course.statementOfResults ? (
          <Button
            size='small'
            startIcon={<GetAppIcon />}
            color='secondary'
            variant='contained'
            onClick={() => handleFileDownload(course.statementOfResults!)}
          >
            Download
          </Button>
        ) : (
          '-'
        )}
      </TableCell>
    </TableRow>
  );
};

export default RowItem;
